import { Box, Button, Container, Grid, IconButton, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react'
import { Redirect } from 'react-router-dom';
import Constantes from '../php/Constantes';
import General from './General';
import Reglamentaria from './Reglamentaria';


const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));


class InformesUsuario extends Component {
    constructor(props){
        super(props);
        this.state = {
            notificaciones: null,
            errores: null,
            consulta: false,
            codigosInforme: [],
            numeroNombre: [],
            lugaresTra: [],
            ubicacionesCentral: [],
            general: false,

            busqueda: {
                codigo: '',
                numeroFuncionario: '',
                nombreFuncionario: '',
                ubicacionBusqueda: '',
                ubicacionCentral: '',
                desde: '',
                hasta: '',
                anio: '',
                dias: '',
            }
        }
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
    }

    async componentDidMount(){

        const codInfo = await fetch(`${Constantes.RUTA_API}/obtener_codigosInformesFuncionarios.php`);
        const datosCodInfo = await codInfo.json();
        this.setState({
            codigosInforme: datosCodInfo,
        });

    }

    render(){
        return (
            <>
                {sessionStorage.login && (sessionStorage.primeraVez === '0')
                ?
                    <Container>
                        <h3>Informes</h3>
                        {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                        {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                        <br/>
                        <Box sx={{ flexGrow: 1}} >
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={2.5}>
                                        <Item>INFORME</Item>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Item>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='codigo'  value={this.state.busqueda.codigo} onChange={this.manejarCambiosDatos}>
                                                <option value=''>INFORMES</option>
                                                {this.state.codigosInforme.map((name) =>
                                                    <option
                                                    key={name.idCodigosInformesFuncionarios}
                                                    value={name.idCodigosInformesFuncionarios}
                                                    >{name.descripcion}</option>
                                                    )}
                                            </select>
                                        </Item>
                                    </Grid>
                                </Grid>
                        </Box>
                        {this.state.busqueda.codigo === '1'
                        ?
                            <Reglamentaria/>
                        :
                            this.state.general
                            ?
                                <General/>
                            :
                                null
                        }
                    </Container>
                :
                    <Redirect to='/login'/>
                }
            </>
        )//Final return
    }//Final render

    manejarCambiosDatos(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
            general: false,
        });
        if((valor === '2')){
            sessionStorage.setItem('codigoInforme', 2);
            this.setState({
                general: true,
            })
        }else if((valor === '4')){
            sessionStorage.setItem('codigoInforme', 4);
            this.setState({
                general: true,
            })
        }else if((valor === '5')){
            sessionStorage.setItem('codigoInforme', 5);
            this.setState({
                general: true,
            })
        }else if((valor === '52')){
            sessionStorage.setItem('codigoInforme', 52);
            this.setState({
                general: true,
            })
        }else if((valor === '40')){
            sessionStorage.setItem('codigoInforme', 40);
            this.setState({
                general: true,
            })
        }else if((valor === '42')){
            sessionStorage.setItem('codigoInforme', 42);
            this.setState({
                general: true,
            })
        }else if((valor === '43')){
            sessionStorage.setItem('codigoInforme', 43);
            this.setState({
                general: true,
            })
        }else if((valor === '37')){
            sessionStorage.setItem('codigoInforme', 37);
            this.setState({
                general: true,
            })
        }else if((valor === '19')){
            sessionStorage.setItem('codigoInforme', 19);
            this.setState({
                general: true,
            })
        }else if((valor === '10')){
            sessionStorage.setItem('codigoInforme', 10);
            this.setState({
                general: true,
            })
        }else if((valor === '49')){
            sessionStorage.setItem('codigoInforme', 49);
            this.setState({
                general: true,
            })
        }else if((valor === '21')){
            sessionStorage.setItem('codigoInforme', 21);
            this.setState({
                general: true,
            })
        }else if((valor === '44')){
            sessionStorage.setItem('codigoInforme', 44);
            this.setState({
                general: true,
            })
        }else if((valor === '51')){
            sessionStorage.setItem('codigoInforme', 51);
            this.setState({
                general: true,
            })
        }else if((valor === '22')){
            sessionStorage.setItem('codigoInforme', 22);
            this.setState({
                general: true,
            })
        }else if((valor === '23')){
            sessionStorage.setItem('codigoInforme', 23);
            this.setState({
                general: true,
            })
        }else if((valor === '20')){
            sessionStorage.setItem('codigoInforme', 20);
            this.setState({
                general: true,
            })
        }else if((valor === '29')){
            sessionStorage.setItem('codigoInforme', 29);
            this.setState({
                general: true,
            })
        }else if((valor === '57')){
            sessionStorage.setItem('codigoInforme', 57);
            this.setState({
                general: true,
            })
        }else if((valor === '11')){
            sessionStorage.setItem('codigoInforme', 11);
            this.setState({
                general: true,
            })
        }else if((valor === '12')){
            sessionStorage.setItem('codigoInforme', 12);
            this.setState({
                general: true,
            })
        }else if((valor === '13')){
            sessionStorage.setItem('codigoInforme', 13);
            this.setState({
                general: true,
            })
        }else if((valor === '35')){
            sessionStorage.setItem('codigoInforme', 35);
            this.setState({
                general: true,
            })
        }else if((valor === '106')){
            sessionStorage.setItem('codigoInforme', 106);
            this.setState({
                general: true,
            })
        }else if((valor === '107')){
            sessionStorage.setItem('codigoInforme', 107);
            this.setState({
                general: true,
            })
        }else if((valor === '108')){
            sessionStorage.setItem('codigoInforme', 108);
            this.setState({
                general: true,
            })
        }else if((valor === '109')){
            sessionStorage.setItem('codigoInforme', 109);
            this.setState({
                general: true,
            })
        }else if((valor === '110')){
            sessionStorage.setItem('codigoInforme', 110);
            this.setState({
                general: true,
            })
        }else{
            this.setState({
                general: false,
            })
        }
        this.setState(state => {
            const numFunActualizado = state.busqueda;
            numFunActualizado[clave] = valor;
            
            return{
                busqueda: numFunActualizado,
            };
        });
    }
}

export default InformesUsuario